import { PuaWarning } from "./PuaWarning";
export default PuaWarning;
